"use strict";

window.onresize = () => {
    flatMobileChecker();
    urlBackFlats();
    menuSet();
    hoverBuildingsSet();
}

window.onload = () => {

    $(document).ready(function () {
        $("a.smooth-scroll").on('click', function (event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function () {
                    window.location.hash = hash;
                });
            }
        });
    });

    magnificPop();

    flatMobileChecker();
    urlBackFlats();
    galleries();
    customSelect();
    clickActive();
    floorActive();
    floorDetailActive();
    floorInfoBanner();
    menu();
    hoverActive();
    hoverActiveFloors();
    hoverBuildingsSet();

    $('.slick-gallery').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        customPaging: function (slider, i) {
            return '<div class="slick-gallery__pager"></div>';
        },
    });


    // Slider
    $('.hero-item__img').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        speed: 1000,
        fade: true,
        cssEase: 'ease-in',
    });

    $('.slick-gallery-flat').slick({
        //centerMode: true,
        center: true,
        autoplay: false,
        autoplaySpeed: 3000,
        //infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('#slickGalleryFlatPrev'),
        nextArrow: $('#slickGalleryFlatNext'),
        //variableWidth: true,
        speed: 800,
        focusOnSelect: true,
        cssEase: 'ease-in-out',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}

function magnificPop() {
    $('.magnificPop').magnificPopup({
        type: 'inline',
        midClick: true,
        closeBtnInside: false
    });
}

function flatMobileChecker() {
    // page "nabidka-bytu-budova" only for desktop
    if (document.querySelector('header').clientWidth <= 1024) {
        let mobileChecker = document.getElementById('mobileChecker');
        if (mobileChecker) {
            window.location = mobileChecker.getAttribute('data-redirect');
        }
    }
}

function urlBackFlats() {
    for (let item of document.getElementsByClassName('urlBackFlats')) {
        if (document.querySelector('header').clientWidth <= 1024) {
            item.setAttribute('href', item.getAttribute('data-mobile'));
        } else {
            item.setAttribute('href', item.getAttribute('data-desktop'));
        }
    }
}

function galleries() {
    new SimpleLightbox('.gallery > a', { /* options */});
    new SimpleLightbox('.open-photo', {});
    new SimpleLightbox('.open-flat-photo', {});

    for (let item of document.querySelectorAll('.gallery-inline')) {
        let id = item.getAttribute('id');
        if (document.getElementById(id)) {
            new SimpleLightbox('#' + id + ' a', {});
            document.getElementById('open-' + id).addEventListener('click', function (e) {
                document.querySelector('#' + id + ' a:first-child').click();
                e.preventDefault();
            }, false);
        }
    }
}

function floorInfoBanner() {
    if (document.querySelector(".signpost-floors__flat")) {
        for (let item of document.querySelectorAll(".signpost-floors__flat")) {
            item.addEventListener("mouseover", function () {
                document.querySelector(".info-banner").classList.remove("is-active");
            })
            item.addEventListener("mouseout", function () {
                document.querySelector(".info-banner").classList.add("is-active");
            })
        }
    }
}

function hoverBuildingsSet() {
    if (document.querySelector(".signpost-buildings__button")) {
        if (document.querySelector('header').clientWidth <= 1024) {
            for (let item of document.querySelectorAll(".signpost-buildings__button")) {
                item.classList.add("is-disable");
                if (item.getAttribute('data-mobile')) {
                    item.href = item.getAttribute('data-mobile');
                }
            }
        } else {
            for (let item of document.querySelectorAll(".signpost-buildings__button")) {
                item.classList.remove("is-disable");
                if (item.getAttribute('data-desktop')) {
                    item.href = item.getAttribute('data-desktop');
                }
            }
        }
    }
}

function hoverActive() {
    if (document.querySelector(".hover-active")) {
        for (let item of document.querySelectorAll(".hover-active")) {
            if (document.getElementById(item.getAttribute("data-target-hover"))) {
                item.onmouseover = function () {
                    if (!item.classList.contains("is-disable")) {
                        this.classList.add("is-active");
                        document.getElementById(item.getAttribute("data-target-hover")).classList.add("is-active");
                    }
                }
                item.onmouseout = function () {
                    if (!item.classList.contains("is-disable")) {
                        this.classList.remove("is-active");
                        document.getElementById(item.getAttribute("data-target-hover")).classList.remove("is-active");
                    }
                }
            }
        }
    }
}

function hoverActiveFloors() {
    if (document.querySelector('.hover-activeF')) {
        for (let item of document.querySelectorAll('.hover-activeF')) {
            if (document.getElementById(item.getAttribute('data-target-hover'))) {
                item.onmouseover = function () {
                    removeIsActive();
                    this.classList.add('is-active');
                    document.getElementById(item.getAttribute('data-target-hover')).classList.add('is-active');
                }
                item.onmouseout = function () {
                    this.classList.remove('is-active');
                    document.getElementById(item.getAttribute('data-target-hover')).classList.remove('is-active');
                    mapFloorMouseOut();
                }
            }
        }
    }
}

function removeIsActive() {
    for (let item of document.getElementsByClassName('ia')) {
        item.classList.remove('is-active');
    }
}

function mapFloorMouseOut() {
    for (let item of document.getElementsByClassName('default')) {
        item.classList.add('is-active');
    }
}

function floorActive() {
    if (document.querySelector(".floor-active")) {
        for (let item of document.querySelectorAll(".floor-active")) {
            let targetID = document.getElementById(item.getAttribute("data-target-floor"));
            if (!item.classList.contains("is-disable") && targetID) {
                item.onclick = function () {
                    if (item.classList.contains("is-active")) {
                        targetID.classList.remove("is-active");
                    } else {
                        targetID.classList.add("is-active");
                    }
                }
            }
        }
    }
}

function floorDetailActive() {
    if (document.querySelector(".floor-detail-active")) {
        for (let item of document.querySelectorAll(".floor-detail-active")) {
            let target = document.getElementById(item.getAttribute("data-target-floor-detail"));
            if (!item.classList.contains("is-disable") && target) {
                item.onclick = function () {
                    if (item.classList.contains("is-active")) {
                        this.classList.remove("is-active");
                        target.classList.remove("is-active");
                        target.style.height = "0";
                    } else {
                        closeFloorDetails();
                        this.classList.add("is-active");
                        target.classList.add("is-active");
                        target.style.height = target.scrollHeight + "px";
                    }
                }
            }
        }
    }
}

function clickActive() {
    if (document.querySelector(".click-active")) {
        for (let item of document.querySelectorAll(".click-active")) {
            if (!item.classList.contains("is-disable") && document.getElementById(item.getAttribute("data-target-click"))) {
                item.onclick = function () {
                    this.classList.toggle("is-active");
                    document.getElementById(item.getAttribute("data-target-click")).classList.toggle("is-active");
                }
            }
        }
    }
}

function closeFloorDetails() {
    for (let closeItem of document.querySelectorAll(".floor-detail-active")) {
        closeItem.classList.remove("is-active");
    }
    for (let closeItem of document.querySelectorAll(".signpost-floors__floor-detail-info-box")) {
        closeItem.classList.remove("is-active");
        closeItem.style.height = "0";
    }
}

function menuSet() {
    if (document.querySelector(".header-menu a")) {
        for (let item of document.querySelectorAll(".header-menu a")) {
            item.onmouseover = null;
            item.onmouseout = null;
        }
    }
    document.querySelector(".header__menu").style.display = null;
    $(".mobileMenuBtn").off();
    menu();
}

function menu() {
    if (document.querySelector(".header").clientWidth <= 1400) {
        $(".mobileMenuBtn").click(function () {
            $(".header__menu").slideToggle();
        });
    } else {
        if (document.querySelector(".header-menu a")) {
            for (let item of document.querySelectorAll(".header-menu a")) {
                item.onmouseover = function () {
                    this.classList.add("is-active");
                }
                item.onmouseout = function () {
                    this.classList.remove("is-active");
                }
            }
        }
        if (document.querySelector(".header-menu__submenu")) {
            document.querySelector(".header-menu__submenu").onmouseover = function () {
                this.children[0].classList.add("is-active");
                this.children[1].classList.remove("hide");
            }
            document.querySelector(".header-menu__submenu").onmouseout = function () {
                this.children[0].classList.remove("is-active");
                this.children[1].classList.add("hide");
            }
        }
    }
}

function customSelect() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /* Look for any elements with the class "custom-select": */
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function (e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener("click", closeAllSelect);
}
